import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const documentMetaTagsResolver: FieldResolver = (metadata: Metadata) =>
  ({ documentMetaTags: metadata.getDocumentMetaTags() } as StreamData)

export default documentMetaTagsResolver
